import { Link } from 'react-router-dom';
import { useAuth } from '../../lib/auth.js';
import { useWorkspace } from '../../lib/workspace.js';
import { PlanCard } from './PlanCard.js';

/**
 * The account page — who you are, and what the workspace you are in is on.
 *
 * Laid out as a call sheet rather than a settings form: the identity is a
 * masthead, not a field, because nothing on this page edits it. Email, name
 * and terms acceptance all come from Cognito and `/me`, and the console has
 * no endpoint that changes them.
 *
 * The plan is workspace-scoped while this page is person-scoped, which is the
 * one thing that could mislead here — so `PlanCard` names the workspace
 * beside the plan rather than leaving "your plan" to be assumed.
 */
export function Account() {
  const { user } = useAuth();
  const { active, can } = useWorkspace();

  if (!user) return null;

  return (
    <section className="account">
      <header className="account-masthead">
        <span className="eyebrow">Account</span>
        {/* Mono, and sized like a heading: in this product the mono face is
            for identifiers people read back — join codes, and this. */}
        <h1 className="account-id">{user.email}</h1>
        {user.name ? <p className="account-sub">{user.name}</p> : null}
      </header>

      {active ? (
        <PlanCard
          workspaceId={active.workspaceId}
          workspaceName={active.name}
          manageable={can('workspace:manage')}
        />
      ) : null}

      {user.termsAcceptedAt ? (
        <p className="account-footnote">
          You accepted the <Link to="/terms">terms of service</Link> and{' '}
          <Link to="/privacy">privacy policy</Link> on{' '}
          {new Date(user.termsAcceptedAt).toLocaleDateString(undefined, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
          .
        </p>
      ) : null}
    </section>
  );
}
